(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('public', {
            abstract: true,
            parent: 'app',
            url: '/public',
            data: {
            }
        });
    }
})();

